import { useQuery } from "react-query";
import { UseQueryOptions } from "react-query/types/react/types";
import { getAssets } from "../api/asset/getAssets";
import { StandardSelectOption } from "../components/selector/parts/SelectOption";
import { queryClient } from "./transactionsStore";
import { formatAssetOption } from "./useQueryAccountAssetOptions";

export const getAllAssetsCacheKey = () => ["allAssets"];

async function getAssetOptions(): Promise<StandardSelectOption[]> {
  const assets = await getAssets();

  // the mapping is expensive, so we do it once on the response and let
  // react query cache the result.
  return assets.map(formatAssetOption);
}

export const useQueryAssetOptions = <TError = unknown>(
  options?: Omit<
    UseQueryOptions<StandardSelectOption[], TError, StandardSelectOption[]>,
    "queryKey" | "queryFn"
  >,
) => {
  return useQuery<StandardSelectOption[], TError, StandardSelectOption[]>(
    getAllAssetsCacheKey(),
    getAssetOptions,
    {
      staleTime: 60 * 60 * 1000,
      ...options,
    },
  );
};

export const prefetchAssets = async () => {
  // The results of this query will be cached like a normal query
  await queryClient.prefetchQuery({
    queryKey: getAllAssetsCacheKey(),
    queryFn: getAssetOptions,
  });
};
